import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAuthenticated: false,
  profile: null,
  accessCrm: null,
};

export const authSlice = createSlice({
  name: "counter",
  initialState,
  reducers: {
    setAuth: (state, action) => {
      state.isAuthenticated = action.payload;
    },
    setProfile: (state, action) => {
      state.profile = action.payload;
    },
    setAccessCrm: (state, action) => {
      state.accessCrm = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setAuth, setProfile, setRole, setAccessCrm } = authSlice.actions;

export default authSlice.reducer;
